module.exports = __webpack_public_path__ + "img/logo-ciudadelaejercito.8998124f.png";